import { render, staticRenderFns } from "./UserMenu.vue?vue&type=template&id=929df040&scoped=true"
import script from "./UserMenu.vue?vue&type=script&lang=js"
export * from "./UserMenu.vue?vue&type=script&lang=js"
import style0 from "./UserMenu.vue?vue&type=style&index=0&id=929df040&prod&lang=less&scoped=true"
import style1 from "./UserMenu.vue?vue&type=style&index=1&id=929df040&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929df040",
  null
  
)

export default component.exports